
import { Utils } from '../utils/Utils';
import { Roles } from '../layouts/Roles';

export const Flexible = {
  onLoad: function () {
    // if ($('.template-flexible').length) {
    AnimatedStats.onLoad()
    this.onLoadCustomerStories()
    this.onLoadEngineering()
    this.onLoadPress()
    this.onLoadVideoSlider()
    this.onLoadTitleAndSlider()
    this.onLoadRoles()
    this.onLoadLogoCarousel()
    this.onLoadMultipleQuotesCarousel()
    // }
  },
  onLoadCustomerStories: function () {
    if ($('#customer-stories').length) {
      $('#customer-stories-carousel').slick({
        arrows: true,
        dots: true,
        // appendDots: '.customer-stories-slider-container',
        nextArrow: $('.customer-stories-slider-next'),
        prevArrow: $('.customer-stories-slider-prev'),
      });
    }
  },
  onLoadEngineering: function () {
    if ($('#engineering-section').length) {
      $('.engineering-reviews-slider').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: true,
        swipeToSlide: true,
        dots: true,
        dotsClass: 'slick-dots left-of-arrow',
        appendDots: '.engineering-slider-container',
        nextArrow: $('.engineering-slider-next'),
        prevArrow: $('.engineering-slider-prev'),
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }],
      });
    }
  },
  onLoadPress: function () {
    if ($('#press').length) {
      $('.press-slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        dots: true,
        // dotsClass: 'slick-dots left-of-arrow',
        // appendDots: '.press-slider-buttons',
        nextArrow: $('.press-slider-next'),
        prevArrow: $('.press-slider-prev'),
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }],
      });
    }
  },
  onLoadVideoSlider: function () {
    if (!$('.column-2-content-and-slider').length) {
      return
    }
    $('.column-2-content-and-slider').each(function () {
      const layout_key = $(this).attr('layout-key')
      const $video_slider = $(this).find('.video-slider')
      $video_slider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        dots: true,
        dotsClass: 'slick-dots active-dot-color_white left-of-arrow',
        appendDots: '[layout-key="' + layout_key + '"] .video-slider-container',
        nextArrow: $(this).find('.video-slider-next'),
        prevArrow: $(this).find('.video-slider-prev'),
      })
    })
  },
  onLoadTitleAndSlider: function () {
    if (!$('.column-title-and-slider').length) {
      return
    }
    $('.column-title-and-slider').each(function () {
      const layout_key = $(this).attr('layout-key')
      const $video_slider = $(this).find('.video-slider')
      $video_slider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        dots: true,
        dotsClass: 'slick-dots active-dot-color_white left-of-arrow',
        appendDots: '[layout-key="' + layout_key + '"] .video-slider-container',
        nextArrow: $(this).find('.video-slider-next'),
        prevArrow: $(this).find('.video-slider-prev'),
      })
    })
  },
  onLoadRoles: function () {
    if ($('#roles').length) {
      Roles.onLoad();
    }
  },
  onLoadLogoCarousel: function () {
    if (!$('.flexible-logo-carousel')) {
      return
    }
    const self = this
    $('.flexible-logo-carousel').each(function () {
      self.loadLogoCarousel($(this))
    })
  },
  loadLogoCarousel: function ($section) {
    let slides_to_show = $section.find('.slides-to-show-json').text().trim()
    let responsive = []
    slides_to_show = JSON.parse(slides_to_show)
    slides_to_show = slides_to_show.reverse()
    slides_to_show.forEach((slide_to_show_rule) => {
      const bp_pixel = getBreakpointPixelByAbbr(slide_to_show_rule.breakpoint)
      const slides_amount = parseInt(slide_to_show_rule.amount)
      responsive.push({
        breakpoint: bp_pixel,
        settings: {
          slidesToShow: slides_amount,
          slidesToScroll: slides_amount,
          arrows: true,
        },
      })
    })
    /*
    responsive = [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ]
    */
    const autoplay_attr = $section.find('.slick-carousel-multiple-items').attr('carousel-autoplay')
    const autoplay = autoplay_attr === 'true' ? true : false
    const data = {
      autoplay: autoplay,
      infinite: true,
      slidesToShow: responsive[0].settings.slidesToShow,
      slidesToScroll: responsive[0].settings.slidesToScroll,
      arrows: true,
      swipeToSlide: true,
      // dots: true,
      // dotsClass: ',
      // appendDots: '',
      nextArrow: $section.find('.slider-btn-next'),
      prevArrow: $section.find('.slider-btn-prev'),
      responsive: responsive,
    }
    $section.find('.slick-carousel-multiple-items').slick(data)
  },
  onLoadMultipleQuotesCarousel: function () {
    if (!$('.multiple-quotes_carousel').length) {
      return
    }
    const self = this
    $('.multiple-quotes').each(function () {
      self.loadMultipleQuotesCarousel($(this))
    })
  },
  loadMultipleQuotesCarousel: function ($section) {
    let slides_to_show = $section.find('.slides-to-show-json').text().trim()
    let responsive = []
    slides_to_show = JSON.parse(slides_to_show)
    slides_to_show = slides_to_show.reverse()
    console.log('slides_to_show', slides_to_show)
    slides_to_show.forEach((slide_to_show_rule) => {
      const bp_pixel = getBreakpointPixelByAbbr(slide_to_show_rule.breakpoint)
      const slides_amount = parseInt(slide_to_show_rule.amount)
      responsive.push({
        breakpoint: bp_pixel,
        settings: {
          slidesToShow: slides_amount,
          slidesToScroll: slides_amount,
          arrows: true,
        },
      })
    })
    const data = {
      infinite: true,
      slidesToShow: responsive[0].settings.slidesToShow,
      slidesToScroll: responsive[0].settings.slidesToScroll,
      arrows: true,
      swipeToSlide: true,
      // dots: true,
      // dotsClass: ',
      // appendDots: '',
      nextArrow: $section.find('.slider-btn-next'),
      prevArrow: $section.find('.slider-btn-prev'),
      responsive: responsive,
    }
    const $carousel = $section.find('.multiple-quotes_carousel')
    $carousel.slick(data)
  },
}

const AnimatedStats = {
  onLoad: function () {
    if (!$('#animated-stats').length) {
      return
    }
    this.load()
    $(document).on('scroll', function () {
      if (!$('#animated-stats').hasClass('loaded')) {
        AnimatedStats.load()
      }
    })
  },
  load: function () {
    const isInViewport = Utils.isInViewport(document.getElementById('animated-stats'))
    if (!isInViewport) {
      return
    }
    $('#animated-stats .stat-value').each(function () {
      let percentagePrefix = ''
      const $stat_value = $(this)
      let value = parseFloat($stat_value.attr('start-value'))
      const increment = parseFloat($stat_value.attr('increment'))
      const end_value = parseInt($stat_value.attr('end-value'))
      AnimatedStats.count(percentagePrefix, $stat_value, value, increment, end_value)
    })
    $('#animated-stats').addClass('loaded')
  },
  count: function (percentagePrefix, $stat_value, value, increment, end_value) {
    const intervalTime = 125
    let timerID = 0
    if (end_value > 0) {
      timerID = setInterval(function () {
        value += increment
        value = (value >= end_value) ? end_value : value
        if (value % 1 === 0) {
          $stat_value.text(percentagePrefix + value)
        } else {
          $stat_value.text(parseFloat(percentagePrefix + value).toFixed(1))
        }
        if (value >= end_value) clearInterval(timerID)
      }, intervalTime)
    }
  },
}

function getBreakpointPixelByAbbr(bp_abbr) {
  if (bp_abbr === 'xs') {
    return 576 // xs 576px
  }
  if (bp_abbr === 'sm') {
    return 768 // sm 768px
  }
  if (bp_abbr === 'md') {
    return 992 // md 992px
  }
  if (bp_abbr === 'lg') {
    return 1200 // lg 1200px
  }
  if (bp_abbr === 'xl') {
    return 1200 // xl lg 1200px
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/Flexible.js